import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { map, filter } from 'rxjs/operators';
import { ProductSelected } from '@webapp/store/products/action-creators';
import { PRODUCT_SELECTED } from '@webapp/store/products/actions';

export const trackPlanSelected = (action$: Observable<ProductSelected>) =>
  action$.pipe(
    ofType(PRODUCT_SELECTED),
    filter((action) => action.product.category === 'PLAN'),
    map((action) => {
      const price = action.product.prices.find((p) => p.frequency === action.frequency)?.value

      if (window.analytics) {
        window.analytics.track('Plan Selected', {
          id: action.product.id,
          name: action.product.name,
          description: action.product.description,
          frequency: action.frequency,
          price: price !== undefined ? price / 100 : undefined
        });
      }
    }),
    filter(() => false)
  )